import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useAuth } from "../../hooks/AuthContext";
import { FeedbackTypeStep } from "./Steps/FeedbackTypeStep";
import { FeedbackContentStep } from "./Steps/FeedbackContentStep";
import { FeedbackSuccessStep } from "./Steps/FeedbackSuccessStep";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import useStyles from "./styles";
import { Typography, useTheme, IconButton, Card } from "@mui/material";
import { ButtonCustom } from "../Botoes/Button";
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import FeedbackRoundedIcon from '@mui/icons-material/FeedbackRounded';

export const feedbackTypes = {
  BUG: {
    title: "Problema",
    icon: "🐛",
    color: "#f44336" // Vermelho para problemas
  },
  IDEA: {
    title: "Ideia",
    icon: "💡", 
    color: "#ff9800" // Laranja para ideias
  },
  OTHER: {
    title: "Outro",
    icon: "💬",
    color: "#2196f3" // Azul para outros
  },
};

export function Feedback() {
  const { user } = useAuth();
  const theme = useTheme();
  const classes = useStyles();
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [feedbackType, setFeedbackType] = useState(null);
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);

  const handleClick = (e) => {
    setOpenFeedback(!openFeedback);
  };

  function handleRestartFeedback() {
    setFeedbackSent(false);
    setFeedbackType(null);
  }

  return (
    user && (
      <>
        <Hidden smDown>
          <Box
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              zIndex: 9999,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 1
            }}
          >
            {openFeedback && (
              <Card 
                sx={{ 
                  mb: 1, 
                  p: 1.5,
                  borderRadius: 3,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`
                }}
              >
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                  Sua opinião é muito importante para nós!
                </Typography>
              </Card>
            )}
            
            <ButtonCustom
              variant="contained"
              size="small"
              onClick={handleClick}
              sx={{
                minWidth: "auto",
                width: 56,
                height: 56,
                borderRadius: "50%",
                p: 0,
                position: "relative",
                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                "&:hover": {
                  boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s ease",
                backgroundColor: openFeedback ? theme.palette.error.main : theme.palette.primary.main,
              }}
            >
              {openFeedback ? (
                <CloseIcon fontSize="medium" />
              ) : (
                <FeedbackRoundedIcon fontSize="medium" />
              )}
              
              {/* Badge de notificação */}
              {!openFeedback && (
                <Box
                  sx={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: theme.palette.secondary.main,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    animation: "pulse 2s infinite",
                    "@keyframes pulse": {
                      "0%": { transform: "scale(1)", opacity: 1 },
                      "50%": { transform: "scale(1.1)", opacity: 0.8 },
                      "100%": { transform: "scale(1)", opacity: 1 },
                    }
                  }}
                >
                  <Typography variant="caption" sx={{ color: "white", fontSize: "0.6rem", fontWeight: "bold" }}>
                    !
                  </Typography>
                </Box>
              )}
            </ButtonCustom>
          </Box>
        </Hidden>

        <Popover
          open={openFeedback}
          onClose={handleClick}
          anchorReference="anchorPosition"
          anchorPosition={{ top: window.innerHeight - 400, left: window.innerWidth - 520 }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
              overflow: "hidden",
              border: `1px solid ${theme.palette.divider}`,
              maxWidth: 400,
              minWidth: 320,
              margin: 2,
            }
          }}
        >
          <Box sx={{ p: 0 }}>
            {feedbackSent ? (
              <FeedbackSuccessStep
                onFeedbackRestartRequested={handleRestartFeedback}
                onClose={handleClick}
              />
            ) : (
              <>
                {!feedbackType ? (
                  <FeedbackTypeStep 
                    onFeedbackTypeChanged={setFeedbackType} 
                    onClose={handleClick}
                  />
                ) : (
                  <FeedbackContentStep
                    feedbackType={feedbackType}
                    onFeedbackRestartRequested={handleRestartFeedback}
                    onFeedbackSent={() => setFeedbackSent(true)}
                    onClose={handleClick}
                  />
                )}
              </>
            )}
          </Box>
        </Popover>
      </>
    )
  );
}